import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { triggerHaptic } from './haptics';

const defaults: ToastOptions = {
  position: 'bottom-center',
  autoClose: 4000,
};

export const showSuccess = (msg: string) => {
  triggerHaptic('success');
  return toast.success(msg, defaults);
};

export const showError = (msg: string) => {
  triggerHaptic('error');
  return toast.error(msg, { ...defaults, autoClose: 6000 });
};

export const showWarning = (msg: string) => {
  triggerHaptic('warning');
  return toast.warn(msg, defaults);
};

export const showInfo = (msg: string) => toast.info(msg, defaults);

/**
 * Toast with an inline action button.
 * Example: showAction('Task logged', 'Undo', () => undoLog())
 */
export const showAction = (
  msg: string,
  actionLabel: string,
  onAction: () => void,
  opts?: Partial<ToastOptions>
) => {
  const content = React.createElement(
    'div',
    { style: { display: 'flex', alignItems: 'center', gap: '12px', width: '100%' } },
    React.createElement('span', { style: { flex: 1 } }, msg),
    React.createElement(
      'button',
      {
        type: 'button',
        onClick: (e: React.MouseEvent) => {
          e.stopPropagation();
          onAction();
        },
        style: {
          flexShrink: 0,
          fontSize: '12px',
          fontWeight: 600,
          padding: '4px 10px',
          borderRadius: '6px',
          border: '1px solid rgba(255,255,255,0.25)',
          background: 'transparent',
          color: '#E8E0D6',
          cursor: 'pointer',
        },
      },
      actionLabel
    )
  );
  return toast(content, { ...defaults, autoClose: 5000, ...opts });
};
